import React from 'react';
import { ShieldIcon, RadioIcon, TruckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { driverPoints, images } from '../data/site';
const icons = [ShieldIcon, RadioIcon, TruckIcon];
export function Drivers() {
  return <section className="w-full bg-white py-24 lg:py-32" data-id="element-169" data-mp="1j8qwomv2bj5r">
      <div className="mx-auto max-w-[1280px] px-6 lg:px-10" data-id="element-170" data-mp="1n7zsdx9nxr3y">
        <div className="grid items-center gap-14 lg:grid-cols-2 lg:gap-20" data-id="element-171" data-mp="1nacgks60kxpg">
          <Reveal data-id="element-172" data-mp="2ayvpn9ww1eil">
            <div className="overflow-hidden rounded-2xl" data-id="element-173" data-mp="2b0g7q020n4zk">
              <img src={images.driver} alt="Hold Fast Hauling driver in branded company apparel beside the refrigerated fleet" className="aspect-[4/3] w-full object-cover object-top transition-transform duration-500 ease-premium hover:scale-[1.03]" data-id="element-174" data-mp="2fvvk0nkdkstv" />
            </div>
          </Reveal>

          <div data-id="element-175" data-mp="2ynocmgvj8c12">
            <Reveal delay={0.05} data-id="element-176" data-mp="2yng2uxuphmu3">
              <p className="flex items-center gap-3 text-[11px] font-bold uppercase tracking-[0.24em] text-ice" data-id="element-177" data-mp="2yohmhqpsfhnf">
                <span className="h-px w-8 bg-ice" aria-hidden="true" data-id="element-178" data-mp="11bgpmpeeit9o" />
                Our People
              </p>
              <h2 className="mt-6 font-display text-3xl font-extrabold leading-[1.05] tracking-tightest text-ink sm:text-4xl lg:text-[3rem]" data-id="element-179" data-mp="wa1651rvgute">
                Professional Drivers. Professional Standards.
              </h2>
              <div className="mt-8 space-y-4 text-base leading-relaxed text-ink-soft" data-id="element-180" data-mp="1k1ewj26gqgbq">
                <p data-id="element-181" data-mp="1k3j7u56oyhm1">Reliable equipment is only part of the equation.</p>
                <p data-id="element-182" data-mp="1fztnxt0yoo7c">
                  Our professional drivers represent Hold Fast Hauling on every mile, maintaining high standards for
                  safety, communication, cargo handling, and on-time performance.
                </p>
              </div>
            </Reveal>

            <dl className="mt-12 divide-y divide-line border-y border-line" data-id="element-183" data-mp="3vs0qq6scpent">
              {driverPoints.map((point, i) => {
              const Icon = icons[i];
              return <Reveal key={point.title} delay={0.04 * i} data-id="element-184" data-mp="1uq1ifuqu3jwb" data-mpi={i}>
                    <div className="group flex items-start gap-5 py-6" data-id="element-185" data-mp="1zo2ye6syr33k">
                      <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-ice-100 text-ice transition-transform duration-200 ease-premium group-hover:scale-110" data-id="element-186" data-mp="1zq73ut6iga5y">
                        <Icon className="h-5 w-5" aria-hidden="true" data-id="element-187" data-mp="28mogk0uiwg3t" />
                      </span>
                      <div data-id="element-188" data-mp="2dlrn5pq5iudw">
                        <dt className="text-[12px] font-bold uppercase tracking-[0.12em] text-ink" data-id="element-189" data-mp="2imp3rxvijgda">{point.title}</dt>
                        <dd className="mt-2 text-sm leading-relaxed text-ink-soft" data-id="element-190" data-mp="2nd5jxpqpxg3c">{point.detail}</dd>
                      </div>
                    </div>
                  </Reveal>;
            })}
            </dl>
          </div>
        </div>
      </div>
    </section>;
}